// Wrapper per chiamare Cloud Functions dal gestionale.
// Tutte le function HTTP sono esposte sotto /api/{nome} via rewrite di
// Firebase Hosting (vedi firebase.json), quindi niente CORS / niente
// URL hardcoded: stessa origin, stesso dominio.

const FUNCTIONS_BASE = '/api';

export async function callFunction(name, body) {
  const res = await fetch(`${FUNCTIONS_BASE}/${name}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}
